import { AxiosResponse } from 'axios';

import { loginApi } from '../../setup/setupApi';
import {
  OauthConnectResponse,
  OauthConnectValues,
  OauthSecretKeyResponse,
  OauthSettings,
  OauthSettingsResponse
} from './types';

// OAuth 2.0
export const getOAuthSettings = (projectId: string): Promise<OauthSettingsResponse> => {
  const { Authorization } = loginApi?.defaults?.headers?.common as unknown as {
    Authorization: string;
  };

  return loginApi
    .get('oauth2/clients', {
      params: { project_id: projectId },
      headers: {
        Authorization: 'undefined',
        'X-SERVER-AUTHORIZATION': Authorization
      }
    })
    .then((res) => res.data);
};

export const getOAuthSecretKey = (projectId: string): Promise<OauthSecretKeyResponse> =>
  loginApi.get(`projects/${projectId}/secret`).then((res) => res.data);
export const connectOAuthAuth = (values: OauthConnectValues): Promise<OauthConnectResponse> => {
  const { Authorization } = loginApi?.defaults?.headers?.common as unknown as {
    Authorization: string;
  };

  return loginApi
    .post<OauthConnectValues, AxiosResponse<OauthConnectResponse>>('oauth2/clients', values, {
      headers: {
        Authorization: 'undefined',
        'X-SERVER-AUTHORIZATION': Authorization
      }
    })
    .then((res) => res.data);
};

export const updateOAuthAuth = (
  id: number,
  values: OauthSettings
): Promise<OauthConnectResponse> => {
  const { Authorization } = loginApi?.defaults?.headers?.common as unknown as {
    Authorization: string;
  };

  return loginApi
    .patch<OauthSettings, AxiosResponse<OauthConnectResponse>>(`oauth2/clients/${id}`, values, {
      headers: {
        Authorization: 'undefined',
        'X-SERVER-AUTHORIZATION': Authorization
      }
    })
    .then((res) => res.data);
};

export const removeOAuthAuth = (id: number): Promise<boolean> => {
  const { Authorization } = loginApi?.defaults?.headers?.common as unknown as {
    Authorization: string;
  };

  return loginApi
    .delete(`oauth2/clients/${id}`, {
      headers: {
        Authorization: 'undefined',
        'X-SERVER-AUTHORIZATION': Authorization
      }
    })
    .then((res) => res.data);
};
